import React from 'react';
import { JcSize, JcUtils } from '../utils/JcUtils';
import { JcBoxProps, JcRow } from './JcBox';
import { JcIcon, JcIconType } from './icon/JcIcon';
import { JcBuiltInIcon } from 'jcsdk';

export enum JcNoticeSeverity {
  INFO = "info",
  WARNING = "warning",
  ERROR = "error",
}

export interface JcNoticeProps extends Omit<JcBoxProps, "spacing" | "alignCenter" | "children"> {
  readonly message: string;
  readonly severity?: JcNoticeSeverity;
}

export const JcNotice: React.FunctionComponent<JcNoticeProps> = (props: JcNoticeProps) => {

  const message = props.message;
  const severity = props.severity ?? JcNoticeSeverity.INFO;

  const boxProps = JcUtils.otherProps(props);
  const commonProps = JcUtils.commonProps(props, [
    "jc-notice-" + severity,
    "jc-notice",
    "jc-note"
  ]);

  const icon = severity === JcNoticeSeverity.INFO ? JcBuiltInIcon.INFORMATION_CIRCLE : JcBuiltInIcon.EXCLAMATION_TRIANGLE;

  return <JcRow {...commonProps} {...boxProps} spacing alignCenter>
    <JcIcon type={JcIconType.BUILT_IN} icon={icon} size={JcSize.EXTRA_SMALL} />
    {message}
  </JcRow>
}